import { type ObservabilityToolType } from 'types/api/status-checks/status-check'
import { type IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

import type { ExternalIntegrationsParams } from 'queries/external-integrations/types'
import type { IntegrationType as LoadGeneratorIntegrationType } from 'utils/load-generators/load-generator-integration-types'

export type ExternalIntegrationAuthenticationParamsBase = {
  name: string
  teamId: string
}

export type ExternalIntegrationLoadGeneratorAuthenticationParams =
  ExternalIntegrationAuthenticationParamsBase & {
    type: string
  }

export type ExternalIntegrationStatusCheckAuthenticationParams =
  ExternalIntegrationAuthenticationParamsBase & {
    domain: string | null
    observabilityToolType?: ObservabilityToolType
  }

export type ExternalIntegrationScmAuthenticationParams =
  ExternalIntegrationAuthenticationParamsBase & {
    domain: string | null
    type: IntegrationType
  }

export const externalIntegrationsQueryKeys = {
  get: (params: ExternalIntegrationsParams) =>
    ['external-integrations', params] as const,
  getLoadGeneratorIntegrations: (params: { teamId: string }) =>
    ['external-integrations/load-generator', params] as const,
  getStatusCheckIntegrations: (params: { teamId: string }) =>
    ['external-integrations/status-check', params] as const
}

export const externalIntegrationsMutationKeys = {
  createLoadGeneratorAuthentication: (params: {
    teamId: string
    type: LoadGeneratorIntegrationType
  }) => ['external-integrations/load-generator', params] as const,
  createScmAuthentication: (teamId: string) =>
    ['external-integrations/scm', { teamId }] as const,
  createStatusCheckAuthentication: (teamId: string) =>
    ['external-integrations/status-check', { teamId }] as const,
  delete: (params?: ExternalIntegrationsParams) =>
    ['external-integrations', params, { method: 'delete' }] as const,
  deleteLoadGeneratorAuthentication: (
    params: ExternalIntegrationLoadGeneratorAuthenticationParams
  ) => ['external-integrations/load-generator', params] as const,
  deleteScmAuthentication: (
    params: ExternalIntegrationScmAuthenticationParams
  ) => ['external-integrations/scm', params] as const,
  deleteStatusCheckAuthentication: (
    params: ExternalIntegrationStatusCheckAuthenticationParams
  ) => ['external-integrations/status-check', params] as const,
  putScmAuthentication: (teamId: string) =>
    ['external-integrations/scm', { teamId }] as const,
  updateLoadGeneratorAuthentication: (
    params: ExternalIntegrationLoadGeneratorAuthenticationParams
  ) => ['external-integrations/load-generator', params] as const,
  updateStatusCheckAuthentication: (teamId: string) =>
    ['external-integrations/status-check', { teamId }] as const
}
